import React, { Component } from 'react';
import { GeckoField, GECKO_CONSTS } from 'ui';
import { AgentOption } from 'components/AgentSelect';
import AsyncSelect from 'components/AsyncSelect';
import GeckoRequest from 'services/gecko-request';
import PropTypes from 'prop-types';

class SenderSelect extends Component {
  static propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func,
    includeBots: PropTypes.bool,
    useUUID: PropTypes.bool,
  };

  static defaultProps = {
    includeBots: false,
    useUUID: false,
  };

  selectFunc({ search, page }) {
    const query = { search, page, includeBots: this.props.includeBots };
    return GeckoRequest.get('/senders', query);
  }

  optionTransform(sender) {
    if (sender.type === 'bot') {
      sender.full_name = `${sender.full_name} (Bot)`;
    }
    return {
      label: sender.full_name,
      value: this.props.useUUID ? sender.uuid : sender.id,
      sender,
    };
  }

  renderOption(option) {
    return <AgentOption {...option.sender} />;
  }

  handleChange(_key, value) {
    this.props.onChange(value);
  }

  render() {
    const field = {
      key: 'value',
      type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
      component: (
        <AsyncSelect
          getUrl="/senders"
          selectFunc={this.selectFunc.bind(this)}
          optionTransform={this.optionTransform.bind(this)}
          field={{
            config: {
              optionRenderer: this.renderOption.bind(this),
              valueRenderer: this.renderOption.bind(this),
              placeholder: 'Select a sender...',
            },
          }}
        />
      ),
    };
    return (
      <div className="SenderSelect">
        <GeckoField
          field={field}
          values={{ value: this.props.value }}
          handler={this.handleChange.bind(this)}
        />
      </div>
    );
  }
}

export default SenderSelect;
